(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection"]) return;
  try {
    
$(function() {
	var collection_body       = $('.collection-text--body');
	var collection_body_table = $('.collection-text--body table');
	var homepage_image        = $('.homepage-image .content--centered');
	var parallax_mirror       = $('.parallax-mirror');

	if (collection_body_table.length) {
		var hero_image   = $(collection_body_table.find('tr:nth-child(1) td').html());
		var mobile_image = $(collection_body_table.find('tr:nth-child(2) td').html());
		var description  = collection_body_table.find('tr:nth-child(3) td').html();

		if (homepage_image.length) {
			hero_image.addClass('medium-down--hide');
			homepage_image.html(hero_image);
		}

		if (description.length) {
          collection_body.find('.h4--body').html(description);
          collection_body.removeClass('hidden');
		}

		if (mobile_image.length) {
			var mobile_image_element = $('<img>');
			mobile_image_element.addClass('mobile-hero-image medium-up--show').attr('src', mobile_image.attr('src'));
			parallax_mirror.addClass('medium-down--hide').parent().append(mobile_image_element);

		}
	} else {
		if (homepage_image.length) {
          homepage_image.html(collection_body.html());
		}
        collection_body.remove();
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.carousel-items').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.carousel-items').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.reviews').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

})();
